import autoBind from 'auto-bind';

import { HTTPClient } from './HTTPClient';

class BaseApi {
	name: string;
	httpClient: HTTPClient;
	constructor(name = '') {
		this.name = name;
		this.httpClient = new HTTPClient(name);
		autoBind(this);
	}
}

export default BaseApi;
